import { DatabaseOutlined } from '@ant-design/icons';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'corporate_reports',
  label: 'Relatórios',
  icon: <DatabaseOutlined />
};

export default generateResources(resource);
